<template>
  <div v-if="!isShowingLoading" :class="$style['container']">
    <SideBar />

    <div :class="[$style['content'], {[$style['menuExpaned']]: isMenuExpanded}]">

      <UsersBalanceTable />
  
    </div>

  </div>
</template>

<script>

import SideBar from '@components/SideBar.vue';
import UsersBalanceTable from '@/components/usersBalance/UsersBalanceTable.vue';

export default {
  name: 'UsersBalancePage',

  data() {
    return {
    };
  },

  components: {
    SideBar,
    UsersBalanceTable,
  },

  async mounted() {
    // await this.fetchData()
  },

  computed: {
    isMenuExpanded() {
      return this.$store.getters['helpers/isMenuExpanded'];
    },
    isShowingLoading() {
      return this.$store.getters['helpers/isShowingLoading'];
    },
  },

  methods: {
    // async fetchData() {
    //   this.$store.dispatch('helpers/showLoading')

    //   try {
    //     const usersBalanceInfo = await usersBalanceService.getTransactionsInfo();

    //     this.usersBalance = usersBalanceInfo.users_balance


    //     this.$store.dispatch('helpers/hideLoading')
    //   } catch (error) {
    //     this.$store.dispatch('helpers/hideLoading')
    //   }
    // },
  }
}
</script>

<style lang="scss" module>
  .container {
    // padding: 32px;
    width: 100%;
    display: flex;

    .content {
      flex: 1;
      padding: 20px 20px 20px 0;
      overflow-x: hidden;
      overflow-y: scroll;

      &.menuExpaned {
        position: absolute;
        margin-left: 45px;
        width: -webkit-fill-available;

        .wrapper-report {
          position: absolute;
          width: 90%;
        }
      }

      .wrapper-report {
        display: flex;
        flex-direction: column;
        gap: 25px;
        flex-wrap: wrap;
        margin-top: 20px;
      }
    }

  }
</style>
